export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_12.3c55f219.jpg";